import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import type {GetCollectionsBySourceResponse} from '@/services/models/collectionsBySourceResponse';


export const collectionsApiSlice = createApi({
    reducerPath: 'collectionsApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getCollections: builder.query<GetCollectionsBySourceResponse, void>({
            query: () => ({
                url: `DynamicKnowledge/collection`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
        addCollectionToAgent: builder.mutation<void, {
            agentId: string;
            collectionUuid: string;
        }>({
            query: ({ agentId, collectionUuid }) => ({
                url: `Collection/agent`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: {
                    agent_id: agentId,
                    collection_uuid: collectionUuid
                },
            }),
        }),
    }),
})

const {
    useGetCollectionsQuery,
    useAddCollectionToAgentMutation,
} = collectionsApiSlice
export const collectionsApiActions = {
    useGetCollectionsQuery,
    useAddCollectionToAgentMutation,
}